<template>
	<div id="plan-form">
		<div class="row">
			<div class="col-md-6">
				<InputText id="title" name="Title" :form="values" :errors="errors"/>
			</div>
			<div class="col-md-6">
				<InputNumber id="price" name="Price" :form="values" :errors="errors"/>
			</div>
			<div class="col-md-6">
				<InputNumber id="max_horses" name="Maximum horses" :form="values" :errors="errors"/>
			</div>
			<div class="col-md-6">
				<InputText id="stripe_plan_id" name="Stripe plan id" :form="values" :errors="errors"/>
			</div>
			<div class="col-md-6">
				<InputCheckbox class="checkboxes" id="inc_multi_yard" name="Includes Multi Yard" :form="values" :errors="errors" />
			</div>
		</div>
		<div class="row">
			<div class="col-md-12 text-right">
				<button class="button-action" @click="save">{{ newPlan ? 'Add Plan' : 'Save Changes' }}</button>
			</div>
		</div>
	</div>
</template>

<script>
import InputText from '../Form/InputText.vue'
import InputNumber from '../Form/InputNumber.vue'
import InputCheckbox from '../Form/InputCheckbox.vue'
import InputSelect from '../Form/InputSelect.vue'

export default {
	components: {
		InputText,
		InputNumber,
		InputCheckbox
	},
	props: [
		'plan',
	],
	data() {
		return {
			values: {},
			errors: {},
			requiredFields: ['title', 'price', 'max_horses'],
			newPlan: true
		}
	},
	methods: {
		formIsValid() {
			let validForm = true

			this.errors = {}

			this.requiredFields.forEach(field => {
				if(!this.values.hasOwnProperty(field) || this.values[field] == '') {
					this.errors[field] = 'This field is required.'
					validForm = false
				}
			})

			return validForm
		},
		save() {
			if(!this.formIsValid()) {
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'Form error - please check and re-submit',
					timeout: 3000
				})
				return
			}

			const action = this.newPlan ? 'create' : 'update'
			const postActionDescription = this.newPlan ? 'Added' : 'Updated'

			this.$store.commit('app/setLoading', true)
			this.$store.dispatch(`plans/${action}`, this.values)
			.then(() => {
				this.$store.commit('app/setLoading', false);
				this.$store.dispatch('app/addAlert', {
					type: 'success',
					message: `Plan ${this.values.title} ${postActionDescription}`,
					timeout: 3000
				})
				this.$emit('close');
			})
			.catch(err => {
				console.log(err)
				this.$store.commit('app/setLoading', false);
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'An Error occurred, please try later',
					timeout: 3000
				})
			})
		}
	},
	mounted() {
		if(this.plan) {
			this.values = JSON.parse(JSON.stringify(this.plan))
			this.newPlan = false
		}
	},
}
</script>

<style lang="scss">
	@import './../../scss/variables';

	#plan-form {
		.checkboxes {
			margin-top: 30px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Plans/Form.vue